import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as Fi from 'react-icons/fi';
import { saveSettings } from '../utils/storage.js';

const SettingsSheet = ({ open, onClose, settings, onSave }) => {
  const [sweatEnabled, setSweatEnabled] = useState(settings.sweatEnabled ?? true);
  const [sweatInterval, setSweatInterval] = useState(settings.sweatInterval ?? 7);
  const [tagEnabled, setTagEnabled] = useState(settings.tagEnabled ?? true);

  // Auto-save on every change
  useEffect(() => {
    const s = { sweatEnabled, sweatInterval, tagEnabled };
    onSave(s);
    saveSettings(s);
  }, [sweatEnabled, sweatInterval, tagEnabled]);

  const Toggle = ({ value, onChange, label, sub }) => (
    <div className="flex items-center justify-between py-3 border-b border-white/[0.06]">
      <div>
        <p className="text-sm font-black text-white">{label}</p>
        {sub && <p className="text-xs text-white/40 font-bold mt-0.5">{sub}</p>}
      </div>
      <button onClick={() => onChange(!value)}
        className="w-12 h-6 rounded-full transition-all relative shrink-0"
        style={{ backgroundColor: value ? '#6366f1' : 'rgba(255,255,255,0.1)' }}>
        <div className="absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-all"
          style={{ left: value ? '1.75rem' : '0.25rem' }} />
      </button>
    </div>
  );

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[160] flex items-end justify-center">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 28, stiffness: 320 }}
            className="relative z-10 w-full max-w-lg bg-[#0d1a2e] border-t border-white/10 rounded-t-3xl px-4 pt-4"
            style={{ paddingBottom: 'max(1.5rem,env(safe-area-inset-bottom))' }}
          >
            <div className="w-10 h-1 rounded-full bg-white/20 mx-auto mb-4" />
            <div className="flex items-center justify-between mb-5">
              <div>
                <h3 className="text-base font-black text-white">比賽設定</h3>
                <p className="text-xs text-emerald-400 font-bold mt-0.5">✓ 自動儲存</p>
              </div>
              <button onClick={onClose} className="text-white/40 hover:text-white bg-white/5 p-2 rounded-xl transition-colors">
                <Fi.FiX />
              </button>
            </div>
            <Toggle value={tagEnabled} onChange={setTagEnabled} label="失誤標記" sub="每分後可快速標記得分原因" />
            <Toggle value={sweatEnabled} onChange={setSweatEnabled} label="擦汗提醒" sub="定時提示擦汗保持場地安全" />
            {sweatEnabled && (
              <div className="py-3 border-b border-white/[0.06]">
                <p className="text-sm font-black text-white mb-3">每 N 分提醒一次</p>
                <div className="flex gap-2">
                  {[5, 7, 10, 15].map(n => (
                    <button key={n} onClick={() => setSweatInterval(n)}
                      className="flex-1 py-2 rounded-xl font-black text-sm transition-all"
                      style={{
                        backgroundColor: sweatInterval === n ? 'rgba(99,102,241,0.3)' : 'rgba(255,255,255,0.06)',
                        color: sweatInterval === n ? '#a5b4fc' : 'rgba(255,255,255,0.5)',
                        border: `1px solid ${sweatInterval === n ? 'rgba(99,102,241,0.5)' : 'rgba(255,255,255,0.1)'}`,
                      }}>
                      {n}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <button onClick={onClose}
              className="w-full mt-4 py-3.5 bg-white/8 hover:bg-white/12 text-white/70 font-black rounded-2xl transition-all active:scale-95 text-sm border border-white/10">
              關閉
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default SettingsSheet;